export const DEFAULT_EXPIRY_TIME = 1000 * 60 * 10; // 10 minutes

/* Format: [ functionName, [ array of functionNames of caches to clear ] ] */
export const ASSOCIATED_REQUESTS = new Map([
  [
    "campaigns-processCampaign",
    [
      "campaigns-getAdminCampaigns",
      "campaigns-getUserCampaigns",
      "campaigns-getAllCampaigns",
      "campaigns-getCampaignsByCompanyID",
    ],
  ],
  [
    "campaigns-createCampaign",
    [
      "campaigns-getAdminCampaigns",
      "campaigns-getUserCampaigns",
      "campaigns-getAllCampaigns",
      "campaigns-getCampaignsByCompanyID",
    ],
  ],
  ["tlcVideos-addVideo", ["tlcVideos-getAllVideos"]],
  ["tlcVideos-updateVideo", ["tlcVideos-getAllVideos"]],
  ["tlcVideos-deleteVideo", ["tlcVideos-getAllVideos"]],
  ["tlcVideos-getFeaturedVideo", ["tlcVideos-getFeaturedVideo"]],
  [
    "campaignDrafts-createCampaignDraft",
    ["campaignDrafts-getCampaignDraftsByTeams"],
  ],
  [
    "campaignDrafts-editCampaignDraft",
    [
      "campaignDrafts-getCampaignDraftsByTeams",
      "campaignDrafts-getCampaignDraftById",
    ],
  ],
  [
    "campaignDrafts-removeCampaignDraft",
    [
      "campaignDrafts-getCampaignDraftsByTeams",
      "campaignDrafts-getCampaignDraftById",
    ],
  ],
  [
    "campaigns-editCampaign",
    [
      "campaigns-getAdminCampaigns",
      "campaigns-getUserCampaigns",
      "campaigns-getAllCampaigns",
      "campaigns-getCampaignsByCompanyID",
    ],
  ],
]);

/* Format: [ functionName, expiryTime (in ms) ] */
// TODO: add different expiry times per function
export const CACHE_EXPIRY_TIMES = new Map([]);
